export class DateRangeFilterWithstudentId
{
    StudentId:any;
    StartDate:any;
    EndDate:any;
    IdleHrs:any='2';
    SessionPerWeek:any='3.5';
}